import { FieldGroup } from '@shared/ui/forms/FormFields';
import { SelectableCardList } from '@shared/ui/forms/SelectableCardList';
import { Banner } from '@shared/ui/feedback/Banner';
import { Skeleton } from '@shared/ui/feedback/Skeleton';
import type { EligibleLocation } from './api';
import { toAccessInviteLocationCardItems } from './accessInviteLocationUi';

/**
 * Property picker shared by the invite composer and gate tabs (Active PINs).
 */
export function AccessInvitePropertyPicker({
  locations,
  selectedId,
  onSelect,
  isLoading,
  isError,
  emptyDescription = 'Link or verify a property on your account before creating visitor invites.',
}: {
  locations: EligibleLocation[];
  selectedId: string;
  onSelect: (locationId: string) => void;
  isLoading?: boolean;
  isError?: boolean;
  emptyDescription?: string;
}): JSX.Element | null {
  if (isError) {
    return <Banner variant="danger" title="Could not load your properties" />;
  }

  if (isLoading) {
    return <Skeleton className="h-12" />;
  }

  if (locations.length === 0) {
    return (
      <Banner
        variant="warning"
        title="No property linked"
        description={emptyDescription}
      />
    );
  }

  return (
    <FieldGroup
      label="Property"
      description={
        locations.length > 1
          ? 'Select the property this visitor will access at the gate.'
          : 'The visitor will be associated with this property at the gate.'
      }
    >
      <SelectableCardList
        items={toAccessInviteLocationCardItems(locations)}
        selectedId={selectedId}
        onSelect={onSelect}
      />
    </FieldGroup>
  );
}
